import React, { useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import HTopbar from '../../hooks/HomeTopBar';
import { fetchSecurityQuestions, setupRecoverySystem } from '@/lib/api/SecurityQuestion';
import { useLocation, useNavigate } from 'react-router-dom';

const SetupSecurityRecover = () => {
  const [allQuestions, setAllQuestions] = useState([]);
  const [selectedQuestions, setSelectedQuestions] = useState(Array(5).fill(''));
  const [answers, setAnswers] = useState({});
  const [loading, setLoading] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();
  const { userId, userType } = location.state || {};

  // Redirect if no user data
  useEffect(() => {
    if (!userId || !userType) {
      navigate('/', { replace: true });
    }

    const loadQuestions = async () => {
      try {
        const response = await fetchSecurityQuestions();
        setAllQuestions(response);
      } catch (error) {
        console.error('Error fetching questions:', error);
      }
    };

    loadQuestions();
  }, [userId, userType, navigate]);

  const handleQuestionChange = (index, questionId) => {
    const newSelected = [...selectedQuestions];
    newSelected[index] = questionId;
    setSelectedQuestions(newSelected);
  };

  const handleAnswerChange = (questionId, value) => {
    setAnswers(prev => ({ ...prev, [questionId]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Check completeness
    const incomplete = selectedQuestions.some(
      id => !id || !answers[id] || answers[id].trim() === ''
    );
    if (incomplete) {
      return alert('Please select and answer all 5 security questions.');
    }

    // Check uniqueness
    const uniqueIds = new Set(selectedQuestions);
    if (uniqueIds.size < selectedQuestions.length) {
      return alert('Each question must be unique.');
    }

    const payload = selectedQuestions.map(qId => ({
      question_id: qId,
      answer_hash: answers[qId].trim(),
    }));

    setLoading(true);
    const start = Date.now(); // track start time

    try {
      await setupRecoverySystem(payload);
      alert('Security questions saved successfully!');

      if (userType === 'sport_participant') navigate('/participant/profile');
      else if (userType === 'sport_organizer') navigate('/organizer/profile');

    } catch (err) {
      console.error(err);
      alert('Failed to save security questions.');
    } finally {
      const elapsed = Date.now() - start;
      const remaining = 2000 - elapsed; // ensure at least 2 sec
      if (remaining > 0) {
        setTimeout(() => setLoading(false), remaining);
      } else {
        setLoading(false);
      }
    }
  };


  return (
    <div
      className="vh-100 vw-100 d-flex flex-column"
      style={{ backgroundColor: '#FF9B54' }}
    >      <HTopbar />
      <div className="container-fluid flex-grow-1 d-flex align-items-center justify-content-center">
        <div
          className="row w-100 shadow rounded-4 overflow-hidden position-relative"
          style={{ maxWidth: '1100px', minHeight: '400px', height: '80vh' }}
        >
          {/* Left Visual */}
          <div className="col-md-6 d-none d-md-block p-0">
            <img
              src="/images/auth/register.jpg"
              alt="Security Visual"
              className="w-100 h-100"
              style={{ objectFit: 'cover' }}
              onError={e => { e.target.onerror = null; e.target.src = ''; }}
            />
          </div>

          {/* Right Form */}
          <div
            className="col-md-6 p-4 d-flex flex-column justify-content-center"
            style={{
              overflowY: 'auto',
              maxHeight: '80vh',
              backgroundColor: '#d66a06ff', // changed from white to orange
            }}
          >            {loading && (
            <div className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center bg-white bg-opacity-75" style={{ zIndex: 10 }}>
              <div className="spinner-border text-dark" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          )}

            <div className="text-center mb-3">
              <h1
                style={{
                  fontSize: '100px',     // bigger font
                  fontWeight: 900,      // extra thick
                  color: '#FFFFFF',
                  margin: 0,
                  letterSpacing: '1px', // optional for style
                }}
              >
                Match<span style={{ color: '#FFFFFF' }}>Up</span>
              </h1>
              <p style={{ color: '#FFFFFF', marginTop: '0.5rem' }}>
                Choose and answer 5 security questions to recover your account.
              </p>
            </div>


            <form onSubmit={handleSubmit}>
              {selectedQuestions.map((selectedId, index) => (
                <div key={index} className="mb-3">
                  <label className="form-label text-muted mb-1">
                    {index + 1}. Choose a security question
                  </label>
                  <select
                    className="form-select mb-1"
                    value={selectedId}
                    onChange={e => handleQuestionChange(index, e.target.value)}
                  >
                    <option value="">-- Select a question --</option>
                    {allQuestions.map(q => (
                      <option
                        key={q.id}
                        value={q.id}
                        disabled={selectedQuestions.includes(q.id) && selectedId !== q.id}
                      >
                        {q.question_text}
                      </option>
                    ))}
                  </select>

                  {selectedId && (
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Your answer"
                      value={answers[selectedId] || ''}
                      onChange={e => handleAnswerChange(selectedId, e.target.value)}
                    />
                  )}
                </div>
              ))}

              <div className="d-grid mt-2">
                <button type="submit" className="btn btn-dark btn-lg rounded-pill" disabled={loading}>
                  {loading ? 'Saving...' : 'Proceed'}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SetupSecurityRecover;
